module.exports = __webpack_public_path__ + "img/编组2.6b90a536.png";